export default __webpack_public_path__ + "static/media/cleraLine.8b898cc4.mp3";